module.exports = __webpack_public_path__ + "img/icon_live_video.7505f98d.gif";